import { isWebView } from '@polyv/web-view-bridge/is-webview';
import langs from '../../assets/locale/lang/product';
import entryMixin from '../../assets/mixins/entry';
import { isMobile } from '@polyv/utils/src/browser';

export default {
  langs,

  mixins: [entryMixin],

  props: {
    /** 商品库 sdk 实例 */
    productSdk: Object,
    /** 获取跳转链接附带参数 */
    getLinkParams: Function,
    /** 获取微信 SDK 对象 */
    getWeixinSdk: Function,
    /**
     * 自定义商品按钮禁用状态
     * (good: ProductData) => unknow
     */
    customProductDisabled: Function,
    /**
     * 自定义点击购买按钮的处理，注意传入该参数后微信小程序跳转原生标签将失效
     * (good: ProductData) => unknow
     */
    customClickButtonHandler: Function,
    /** 获取保利威 SDK 桥接器对象 */
    getPlvWebviewBridge: Function,
    /** 是否为保利威 SDK Webview 环境 */
    isPlvWebview: {
      type: [Boolean, undefined],
      default: undefined,
    },
    productLinkJumpTipEnabled: {
      type: [String, Boolean],
      default: false,
    },
    /** webview 数据的尺寸信息 */
    plvWebviewDataSize: {
      type: Object,
      default: () => ({ width: 90, height: 160 })
    },
    /** 招聘开关 */
    recruitmentEnabled: {
      type: [String, Boolean],
      default: false,
    },
    hotEffectTipOption: {
      type: Object,
      default: () => ({})
    },
    hotEffectEnabled: {
      type: Boolean,
      default: false
    },

    /**
     * 是否不展示商品详情，直接跳转到外部链接
     */
    redirectDirectlyEnabled: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isPlvWebview: {
      immediate: true,
      handler() {
        if (typeof this.isPlvWebview === 'boolean') {
          this.innerIsPlvWebview = this.isPlvWebview;
        } else {
          this.innerIsPlvWebview = isWebView();
        }
      }
    }
  },

  provide() {
    return {
      productVm: this,
    };
  },

  data() {
    return {
      // 当前是否为保利威 SDK Webview 环境
      innerIsPlvWebview: false,
    };
  },

  methods: {
    _getCoreSdk() {
      return this.productSdk;
    },
    /**
     * 回调点击商品详情
     * @param {Object} good 商品信息
     */
    emitClickGoodDesc(good) {
      this.$emit('click-good-desc', good);
    },

    /**
     * 回调点击商品购买按钮
     * @param {Object} good 商品信息
     */
    emitClickBuy(good) {
      let sendClick = 'N';

      if (this.productLinkJumpTipEnabled === 'Y' || this.productLinkJumpTipEnabled === true) {
        sendClick = 'Y';
      }

      if (this.hotEffectEnabled === 'Y' || this.hotEffectEnabled === true) {
        sendClick = 'Y';
      }

      if (this.productSdk) {
        this.productSdk.clickBuyProduct(good, sendClick);
        this.clickBuyTrackLog(good);
      }

      this.$emit('click-buy', good);
    },

    /**
     * 回调弹框购买（外链）
     * @param {Object} href 外链地址
     */
    emitPopupPage(href) {
      this.$emit('popup-page', href);
    },

    /**
     * 回调点击商品小窗 webview 跳转
     * @param {Object} good 商品信息
     */
    emitClickPlvWebviewJump(good) {
      this.$emit('click-plv-webview-jump', good);
    },

    clickBuyTrackLog(good) {
      let eventId = 'product_list_item_click';

      if (this.getClickBuyTrackEventId) {
        eventId = this.getClickBuyTrackEventId();
      }

      const trackLogData = {
        event_cata: 'behavior',
        event_type: 'click',
        event_id: eventId,
        spec_attrs: {
          clickTime: new Date().getTime(),
          linkType: isMobile() ? 'mobile' : 'pc',
          productName: good.name,
          productId: good.productId,
          productType: good.productType,
          feature: good.features,
          price: good.price,
          realPrice: good.realPrice,
        }
      };
      // 需要对齐线上商品库埋点字段 linkType
      if (this.good && this.good.logId) {
        trackLogData.spec_attrs.pushId = this.good.logId;
      }
      this.productSdk.trackLog(trackLogData);
    },
    /**
     * @description: 直接购买
     * @param {object} product 商品信息
     * @return {void}
     */
    emitBuy(product) {
      this.$emit('buy', product);
    },

    /**
     * 获取商品讲解
     */
    getProductExplainEnabled() {
      if (!this.productSdk) return false;
      return this.productSdk.getProductExplainEnabled();
    },
  },
};
